/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Verified({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Verified_svg__a)"><path d="M11.475 5.867a.6.6 0 1 0-.95-.733L7.118 9.549 5.456 7.61a.6.6 0 1 0-.912.782l2.143 2.5a.6.6 0 0 0 .93-.024l3.858-5Z" /><path fillRule="evenodd" d="M9.14 1.302a1.6 1.6 0 0 0-2.28 0L5.71 2.47l-1.64-.012A1.6 1.6 0 0 0 2.458 4.07l.012 1.64-1.168 1.15a1.6 1.6 0 0 0 0 2.28l1.168 1.15-.012 1.64a1.6 1.6 0 0 0 1.612 1.612l1.64-.012 1.15 1.168a1.6 1.6 0 0 0 2.28 0l1.15-1.168 1.64.012a1.6 1.6 0 0 0 1.612-1.612l-.012-1.64 1.168-1.15a1.6 1.6 0 0 0 0-2.28L13.53 5.71l.012-1.64a1.6 1.6 0 0 0-1.612-1.612l-1.64.012-1.15-1.168Zm-1.425.842a.4.4 0 0 1 .57 0l1.18 1.198a1.1 1.1 0 0 0 .792.328l1.682-.012a.4.4 0 0 1 .403.403l-.012 1.682a1.1 1.1 0 0 0 .328.792l1.198 1.18a.4.4 0 0 1 0 .57l-1.198 1.18a1.1 1.1 0 0 0-.328.792l.012 1.682a.4.4 0 0 1-.403.403l-1.682-.012a1.1 1.1 0 0 0-.792.328l-1.18 1.198a.4.4 0 0 1-.57 0l-1.18-1.198a1.1 1.1 0 0 0-.792-.328l-1.682.012a.4.4 0 0 1-.403-.403l.012-1.682a1.1 1.1 0 0 0-.328-.792l-1.198-1.18a.4.4 0 0 1 0-.57l1.198-1.18a1.1 1.1 0 0 0 .328-.792L3.658 4.06a.4.4 0 0 1 .403-.403l1.682.012a1.1 1.1 0 0 0 .792-.328l1.18-1.198Z" clipRule="evenodd" /></g><defs><clipPath id="Verified_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;